module.exports = __webpack_public_path__ + "static/media/logo.08bdb0eb.png";